import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { ReactElement } from 'react';
import VoxelIconButton from '../Buttons/VoxelIconButton';
import VoxelDialogSubtitle from './VoxelDialogSubtitle';
import VoxelDialogTitle from './VoxelDialogTitle';
import { zIndexVoxel } from '../../../logic/zIndexVoxel';

export interface VoxelDialogProps {
  open: boolean;
  onClose: () => void;
  closeDisabled?: boolean;
  hideClose?: boolean;
  title?: string;
  titleIcon?: ReactElement<FontAwesomeIconProps>;
  subtitle?: string;
  maxWClass?: string;
  minWClass?: string;
  backdropClasses?: string;
  closeOnBackdrop?: boolean;
  onMouseDown?: (event: React.MouseEvent<any>) => void;
  sidePanelsRight?: ReactElement[];
  sidePanelsLeft?: ReactElement[];
}

const VoxelDialog: React.FC<VoxelDialogProps> = ({
  children,
  open,
  onClose,
  closeDisabled,
  hideClose = false,
  title,
  titleIcon,
  subtitle,
  maxWClass = 'max-w-2xl',
  backdropClasses,
  minWClass = 'min-w-[300px]',
  closeOnBackdrop = true,
  onMouseDown,
  sidePanelsRight,
  sidePanelsLeft,
}) => {
  return (
    <div
      onClick={closeOnBackdrop ? onClose : () => { }}
      onMouseDown={onMouseDown}
      className={`
        ${open ? '' : 'hidden'} 
        cursor-default
        overflow-y-auto overflow-x-hidden 
        top-0 right-0 left-0
        fixed
        ${zIndexVoxel.dialogBackdrop}
        w-full inset-0 min-h-screen h-full max-h-full
        bg-[#B7BCC5]/70
        ${backdropClasses}
        `}
    >
      <div
        onClick={(event) => event.stopPropagation()}
        onMouseDown={onMouseDown}
        className={`
        ${zIndexVoxel.dialogWindow}
        relative mx-auto p-4
        h-auto max-h-full
        top-1/2 -translate-y-1/2
        w-full ${maxWClass}
        `}
      >
        <div className={`flex flex-row justify-center items-center gap-3`}>
          {sidePanelsLeft}
          <form
            onSubmit={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
          >
            <div
              className={`
              relative  w-full h-full
              rounded-xl
              bg-white shadow-lg
              ${minWClass}
              
            `}
            >
              {/* Close button */}
              {!hideClose && (
                <div className="absolute top-3 right-3 z-10">
                  <VoxelIconButton
                    size="lg"
                    color="white"
                    icon={<FontAwesomeIcon title={'Close'} icon={faXmark} size="xl" />}
                    onClick={onClose}
                    disabled={closeDisabled}
                    onMouseDown={onMouseDown}
                    type="button"
                  />
                </div>
              )}

              {/* Relative content */}
              <div className="relative">
                {/* Title */}
                {!!title?.length && <VoxelDialogTitle title={title} titleIcon={titleIcon} />}
                {/* Subtitle */}
                {!!subtitle?.length && <VoxelDialogSubtitle> {subtitle} </VoxelDialogSubtitle>}
                {/* Content */}
                {children}
              </div>
            </div>
          </form>
          {sidePanelsRight}
        </div>
      </div>
    </div>
  );
};

export default VoxelDialog;
